import api from "../..";
import { DeleteBannerParams } from "./types";

export const deleteBanner = async ({ uuid }: DeleteBannerParams): Promise<boolean> => {

  return await api.delete(`admin/banner/${uuid}/`)
  .then(() => true)
  .catch(() => false);
};
